// extracted by mini-css-extract-plugin
export default {"emptyWrapper":"Empty_emptyWrapper__5Rq-U"};